export interface TrackingFeatureData {
    id: string;
    name: string;
    status: string;
    labels: { [key: string]: string[] };
    parentId?: string;
    position?: number;
    variationId?: string;
}

export class TrackingFeature {
    private readonly data: TrackingFeatureData;
    private readonly children: TrackingFeature[] = [];

    public static createRootFeature(id: string, name: string, status: string, labels: { [key: string]: string[] }): TrackingFeature {
        return new TrackingFeature(id, name, status, labels);
    }

    private constructor(
        id: string,
        name: string,
        status: string,
        labels: { [key: string]: string[] },
        position?: number,
        parentId?: string,
        variationId?: string
    ) {
        this.data = {
            id,
            name,
            status,
            labels
        };
        if (position) {
            this.data.position = position;
        }
        if (parentId) {
            this.data.parentId = parentId;
        }
        if (variationId) {
            this.data.variationId = variationId;
        }
    }

    public addChild(idPartPrefix: string, name: string, status: string, labels: { [key: string]: string[] }): TrackingFeature {
        const childPosition = this.children.length + 1;
        const childId = `${this.data.id}-${idPartPrefix}${childPosition}`;
        const child = new TrackingFeature(childId, name, status, labels, this.children.length + 1, this.data.id);
        this.children.push(child);
        return child;
    }

    public toArray(): TrackingFeatureData[] {
        let result: TrackingFeatureData[] = [];
        result.push(this.data);
        this.children.forEach(children => {
            result = result.concat(children.toArray());
        });
        return result;
    }

    setParentId(parentId: string) {
        this.data.parentId = parentId;
    }

    setPosition(position: number) {
        this.data.position = position;
    }

    setVariationId(variationId: string) {
        this.data.variationId = variationId;
    }
}
